import { Component, OnInit } from '@angular/core';
import { TenantConfigService } from 'src/app/shared/services/tenant-config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { ErrorResponse } from 'src/app/core/data-models/shared.data-models';
import { UserDataService } from 'src/app/core/data-services/identity/user.data.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { JariValidators } from 'src/app/shared/shared/jari-validators';

@Component({
  selector: 'app-complete-register',
  templateUrl: './complete-register.component.html',
  styleUrls: ['./complete-register.component.scss']
})
export class CompleteRegisterComponent implements OnInit {
  companyName: string = '';
  nationalId!: string;
  otp!: string;
  nationalIdPattern = JariValidators.saudiNationalIdPattern;

  constructor(private tenantConfigService: TenantConfigService, 
    private userDataService: UserDataService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    public languageService: LanguageService,
  ) {
    this.companyName = localStorage.getItem('currentLang') === 'ar' && this.tenantConfigService.tenant.companyNameAr ? this.tenantConfigService.tenant.companyNameAr : this.tenantConfigService.tenant.companyName; 
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.otp = params.get('otp')!;
    });
  }


  verifyInvitedUser() {
    this.userDataService.validateInvitedUser(this.nationalId, this.otp).subscribe({
      next: (res) => {
        if (res.message == "2001") {
          this.router.navigate(['authentication/login'])
        }
        //2002 means that user verified yakeen and otp not required 
        //  res.success = true it means that user not verified yakeen and show otp screen
        if ((!res.success && res.message == "2002") || res.success) {
          var credentials = {
            phoneNumber: res.resource.phoneNumber,
            requireOtp: res.success,
            transactionId: res.resource.transactionId
          }
          this.router.navigate(['authentication/set-password-registration'], { state: credentials });
        }


      },
      error: (err: ErrorResponse) => {
        let msg = err && err.error && err.error.message ? err.error.message : 'Shared.SOMETHING_WENT_WRONG'
        this.notificationService.error(msg)
      }
    });
  }

}
